export default {
  "bbt.header.title": "Blockbuster TOKYO",
  "bbt.header.linkj": "LINK-J",
  "bbt.header.cic": "CIC",
  "bbt.header.mri": "MRI",
  "bbt.header.menu": "Menu",
} as const;
